import { IndustryCategory } from '../../../domain'
import {
  OrganizationBreakdown,
  OrganizationBreakdownEntry,
  OrganizationBreakdownIndustry,
  OrganizationBreakdownByIndustryEntry,
} from '../OrganizationBreakdown'

export const groupOrganizationsByIndustry = ({
  organizationEntries,
}: OrganizationBreakdown): OrganizationBreakdownIndustry => {
  // industryBuckets are buckets of ICB industry string to arrays of entries, for no industry use code UNDEFINED_INDUSTRY
  const industryBuckets = new Map<IndustryCategory, OrganizationBreakdownEntry[]>()
  organizationEntries.forEach((entry) => {
    const { industryCategory } = entry.organization
    const array = industryBuckets.get(industryCategory)
    if (array) {
      industryBuckets.set(industryCategory, [...array, entry])
    } else {
      industryBuckets.set(industryCategory, [entry])
    }
  })

  // turn into array and calculate sums and organize by weight
  const industries: OrganizationBreakdownByIndustryEntry[] = Array.from(industryBuckets.entries()).map(
    ([industryCategory, organizations]) => {
      const totalPercentage = organizations.reduce((sum, breakdown) => {
        return sum + breakdown.percentageWeight
      }, 0)
      organizations.sort((a, b) => b.percentageWeight - a.percentageWeight)
      return { industryCategory, organizations, totalPercentage }
    }
  )

  // sort
  industries.sort((a, b) => {
    return b.totalPercentage - a.totalPercentage
  })
  return { industries }
}

export const calculateIndustryOther = ({ cash, others }: OrganizationBreakdown): number => {
  const totalCash =
    cash?.reduce((sum, breakdown) => {
      return sum + breakdown.weight
    }, 0) || 0
  const othersTotal = others || 0
  return totalCash + othersTotal
}
